/**
 * Catálogo UI de proveedores IA — claves idénticas a
 * `watoolx/backend/src/constants/aiProviderCatalog.ts`
 */

export const DEFAULT_AI_PROVIDER = "openrouter-openai";

/** Etiquetas cortas para listas y dropdown */
export const AI_PROVIDER_LABELS = {
  "openai-oficial-gpt4": "OpenAI Oficial (GPT-4)",
  "openai-oficial-gpt4-turbo": "OpenAI Oficial (GPT-4 Turbo - 128k tokens)",
  "openai-oficial-gpt35": "OpenAI Oficial (GPT-3.5 Turbo - económico)",
  "openai-oficial-gpt4o": "OpenAI Oficial (GPT-4o)",
  "openai-oficial-gpt4o-mini": "OpenAI Oficial (GPT-4o mini — económico)",
  "openai-oficial-gpt41-mini": "OpenAI Oficial (GPT-4.1 mini — recomendado tools/agendas)",
  "openai-oficial-gpt41": "OpenAI Oficial (GPT-4.1)",
  "gemini-oficial-flash": "Google Gemini oficial (2.0 Flash)",
  "gemini-oficial-flash-15": "Google Gemini oficial (2.5 Flash)",
  "gemini-oficial-pro": "Google Gemini oficial (2.5 Pro)",
  "anthropic-oficial-claude-sonnet": "Anthropic Claude 3.5 Sonnet (oficial)",
  "anthropic-oficial-claude-haiku": "Anthropic Claude 3.5 Haiku (oficial)",
  "anthropic-oficial-claude-opus": "Anthropic Claude 3 Opus (oficial)",
  "openrouter-openai": "OpenRouter (OpenAI GPT-4o mini)",
  "openrouter-openai-gpt35": "OpenRouter (OpenAI GPT-3.5 Turbo)",
  "openrouter-gpt4o-mini": "OpenRouter (GPT-4o mini)",
  "openrouter-openai-gpt4o": "OpenRouter (OpenAI GPT-4o)",
  "openrouter-deepseek": "OpenRouter (DeepSeek)",
  "openrouter-meta": "OpenRouter (Meta Llama 3.3 70B)",
  "openrouter-anthropic": "OpenRouter (Claude 3.5 Sonnet)",
  "openrouter-gemini": "OpenRouter (Gemini 2.0 Flash)",
  "openrouter-qwen": "OpenRouter (Qwen 2.5 72B)",
  "openrouter-kimi-k2": "OpenRouter (Kimi K2 — Moonshot)",
  openai: "OpenAI GPT-3.5 (legacy)",
  openrouter: "OpenRouter (predeterminado)"
};

export function getProviderLabel(provider) {
  if (!provider) return "Sin proveedor";
  return AI_PROVIDER_LABELS[provider] || provider;
}

export function getProviderKeyKind(provider) {
  const p = (provider || "").trim();
  if (p.startsWith("openai-oficial")) return "openai";
  if (p.startsWith("gemini-oficial")) return "gemini";
  if (p.startsWith("anthropic-oficial")) return "anthropic";
  return "openrouter";
}

export function getApiKeyUi(provider) {
  const kind = getProviderKeyKind(provider);
  if (kind === "openai") {
    return {
      label: "API Key de OpenAI",
      placeholder: "sk-...",
      helper: "Tu clave API de OpenAI (sk-...)"
    };
  }
  if (kind === "gemini") {
    return {
      label: "API Key de Google AI Studio",
      placeholder: "AIza...",
      helper: "Clave de Google AI Studio (Gemini API, compatible OpenAI)"
    };
  }
  if (kind === "anthropic") {
    return {
      label: "API Key de Anthropic",
      placeholder: "sk-ant-api...",
      helper: "Clave API de Anthropic (sk-ant-...)"
    };
  }
  return {
    label: "API Key de OpenRouter",
    placeholder: "sk-or-v1-...",
    helper: "Tu clave API de OpenRouter"
  };
}

/**
 * Secciones del <Select> (orden = orden en UI)
 * useProviderChipClass: usa `classes.providerChip` del modal
 */
export const AI_PROVIDER_MENU_SECTIONS = [
  {
    header: "OpenAI Oficial",
    items: [
      {
        value: "openai-oficial-gpt41-mini",
        chip: "OpenAI",
        chipStyle: { backgroundColor: "#10a37f", color: "white", fontWeight: "bold" }
      },
      {
        value: "openai-oficial-gpt41",
        chip: "OpenAI",
        chipStyle: { backgroundColor: "#10a37f", color: "white", fontWeight: "bold" }
      },
      {
        value: "openai-oficial-gpt4o-mini",
        chip: "OpenAI",
        chipStyle: { backgroundColor: "#10a37f", color: "white", fontWeight: "bold" }
      },
      {
        value: "openai-oficial-gpt4o",
        chip: "OpenAI",
        chipStyle: { backgroundColor: "#10a37f", color: "white", fontWeight: "bold" }
      },
      {
        value: "openai-oficial-gpt4",
        chip: "OpenAI",
        chipStyle: { backgroundColor: "#10a37f", color: "white", fontWeight: "bold" }
      },
      {
        value: "openai-oficial-gpt4-turbo",
        chip: "OpenAI",
        chipStyle: { backgroundColor: "#10a37f", color: "white", fontWeight: "bold" }
      },
      {
        value: "openai-oficial-gpt35",
        chip: "OpenAI",
        chipStyle: { backgroundColor: "#10a37f", color: "white", fontWeight: "bold" }
      }
    ]
  },
  {
    header: "Google Gemini Oficial",
    items: [
      {
        value: "gemini-oficial-flash",
        chip: "Gemini",
        chipStyle: { backgroundColor: "#4285f4", color: "white", fontWeight: "bold" }
      },
      {
        value: "gemini-oficial-flash-15",
        chip: "Gemini",
        chipStyle: { backgroundColor: "#4285f4", color: "white", fontWeight: "bold" }
      },
      {
        value: "gemini-oficial-pro",
        chip: "Gemini",
        chipStyle: { backgroundColor: "#4285f4", color: "white", fontWeight: "bold" }
      }
    ]
  },
  {
    header: "Anthropic Claude Oficial",
    items: [
      {
        value: "anthropic-oficial-claude-sonnet",
        chip: "Claude",
        chipStyle: { backgroundColor: "#d97757", color: "white", fontWeight: "bold" }
      },
      {
        value: "anthropic-oficial-claude-haiku",
        chip: "Claude",
        chipStyle: { backgroundColor: "#d97757", color: "white", fontWeight: "bold" }
      },
      {
        value: "anthropic-oficial-claude-opus",
        chip: "Claude",
        chipStyle: { backgroundColor: "#d97757", color: "white", fontWeight: "bold" }
      }
    ]
  },
  {
    header: "OpenRouter (Múltiples modelos)",
    items: [
      { value: "openrouter-openai", chip: "OpenAI", useProviderChipClass: true },
      { value: "openrouter-gpt4o-mini", chip: "OpenAI", useProviderChipClass: true },
      { value: "openrouter-openai-gpt4o", chip: "OpenAI", useProviderChipClass: true },
      { value: "openrouter-openai-gpt35", chip: "OpenAI", useProviderChipClass: true },
      { value: "openrouter-kimi-k2", chip: "Kimi", useProviderChipClass: true },
      { value: "openrouter-deepseek", chip: "DeepSeek", useProviderChipClass: true },
      { value: "openrouter-meta", chip: "Meta", useProviderChipClass: true },
      { value: "openrouter-anthropic", chip: "Claude", useProviderChipClass: true },
      { value: "openrouter-gemini", chip: "Gemini", useProviderChipClass: true },
      { value: "openrouter-qwen", chip: "Qwen", useProviderChipClass: true }
    ]
  }
];
